// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Dynamic report file'" >
    <button class="btn btn-primary"
              ng-disabled="!\$ctrl.reportFile.id"
              command-access="UpdateDynamicReport"
              type="button"
              ng-click="\$ctrl.uploadDownloadMapping()">
        Upload/Download mapping
      </button>
    </sub-header>

  <form name="\$ctrl.form">
    <form-section form-title="'File details'">
      <form-section-field field-title="'File name'">
        <input ng-model="\$ctrl.reportFile.name"
               required
               type="text"
               pattern="..*(\\.xls|\\.xlsx)"
               data-toggle="tooltip"
               data-placement="top"
               title="Filename must end in .xls or .xlsx">
      </form-section-field>
      <form-section-field field-title="'File source'">
        <select ng-model="\$ctrl.fileSource"
                ng-options="value | prettyEnum for value in \$ctrl.fileSources"
                ng-change="\$ctrl.clearFiles()"
                required>
        </select>
      </form-section-field>
      <form-section-field field-title="'File'" ng-if="\$ctrl.fileSource">
        <select ng-model="\$ctrl.reportFile.filePath"
                ng-options="value | prettyEnum for value in \$ctrl.diskFiles"
                ng-if="\$ctrl.fileSource === 'PROVIDED'"
                required>
        </select>
        <file-id-upload
          ng-if="\$ctrl.fileSource === 'UPLOAD'"
          ng-model="\$ctrl.reportFile.attachedFilesId"
          single-file="true"
          max-files="1"
          show-file-name="true"
          enable-webcam="false"
          validate="{pattern: '.xls,*.xlsx', size: { max: '20MB'}}"
          show-remarks="false"
          required>
        </file-id-upload>
      </form-section-field>
    </form-section>

    <dynamic-report-mapping-manual
      max-height="400px"
      ng-if="\$ctrl.reportFile.id">
    </dynamic-report-mapping-manual>

  <dynamic-report-mapping-edit row-data="\$ctrl.mapping"  ng-if="\$ctrl.reportFile.id"></dynamic-report-mapping-edit>
  </form>

  <div class="clearfix"></div>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.testMapping()">
      Test all mappings
    </button>
    <button
      type="button"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.save()">
      Save changes
    </button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/dynamic-report/file/dynamic-report-file.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;